import classNames from "classnames"
import { useController } from "react-hook-form"
import ReactInputMask, { Props as InputMaskProps } from "react-input-mask"
import { FieldProps } from "../../types/FieldProps"
import { FormErrorText } from "../FormErrorText"
import { FormHelperText } from "../FormHelperText"
import { FormLabel } from "../FormLabel"

interface TextFieldProps extends FieldProps {
  inputProps?: Omit<InputMaskProps, "mask" | "maskPlaceholder">
  className?: string
  mask?: InputMaskProps["mask"]
  maskPlaceholder?: InputMaskProps["maskPlaceholder"]
  textTransform?: string | null
}

export function TextField(props: TextFieldProps) {
  const {
    field,
    fieldState: { error },
  } = useController(props)

  const {
    label,
    name,
    inputProps,
    helperText,
    className,
    mask = "",
    maskPlaceholder = "",
    textTransform,
    placeholder,
    subText,
    optional,
    maximumCharacters,
  } = props

  return (
    <div className={classNames("flex flex-col", className)}>
      <div className="flex flex-row justify-between">
        <FormLabel className="pb-[var(--alias-padding-xxs)]" htmlFor={name}>
          {label || name}
          {!optional && <span className="text-red-500">*</span>}
        </FormLabel>
        {subText && (
          <FormLabel
            className="pb-[var(--alias-padding-xxs)] mr-5"
            htmlFor={name}
          >
            {subText}
          </FormLabel>
        )}
      </div>
      <ReactInputMask
        mask={mask}
        maskPlaceholder={maskPlaceholder}
        placeholder={placeholder}
        maxLength={maximumCharacters}
        id={name}
        {...field}
        value={field.value || ""}
        {...inputProps}
        className={classNames(
          "form-field",
          "h-[var(--component-text-input-height)]",
          {
            "form-field error": error,
          },
          inputProps?.className,
          textTransform,
        )}
      />
      {helperText?.length ? (
        <FormHelperText
          htmlFor={name}
          className="pt-[var(--alias-padding-xxs)] mr-auto"
        >
          {helperText}
        </FormHelperText>
      ) : null}
      {error && (
        <FormErrorText className="pt-[var(--alias-padding-xxs)]">
          {error.message}
        </FormErrorText>
      )}
    </div>
  )
}
